import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { STICKY_NOTES, SHORTCUTS_NOTE } from '../data/config';

const StickyNote = () => {
  const [noteIndex] = useState(() => Math.floor(Math.random() * STICKY_NOTES.length));
  const note = STICKY_NOTES[noteIndex];

  return (
    <>
      {/* Random note */}
      <motion.div
        className="sticky-note"
        initial={{ rotate: -2, scale: 0.9 }}
        animate={{ rotate: -2, scale: 1 }}
        drag
        dragMomentum={false}
        whileHover={{ scale: 1.02 }}
      >
        <div className="sticky-title">{note.title}</div>
        <div className="sticky-content">{note.content}</div>
      </motion.div>

      {/* Shortcuts note */}
      <motion.div
        className="sticky-note sticky-note-shortcuts"
        initial={{ rotate: 2, scale: 0.9 }}
        animate={{ rotate: 2, scale: 1 }}
        drag
        dragMomentum={false}
        whileHover={{ scale: 1.02 }}
      >
        <div className="sticky-title">{SHORTCUTS_NOTE.title}</div>
        <div className="sticky-content">{SHORTCUTS_NOTE.content}</div>
      </motion.div>
    </>
  );
};

export default StickyNote;
